import { createStackSiderViewHook } from '@/providers/StackSiderViewProvider';

export const useCommentStackSiderView = createStackSiderViewHook('comment');
